var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_51327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 8.16217H1.74994C0.784973 8.16217 0 7.3772 0 6.41205V1.91205C0 0.947083 0.784973 0.162109 1.74994 0.162109H9.24994C10.2151 0.162109 11.0001 0.947083 11.0001 1.91205V6.41205C11.0001 7.3772 10.2151 8.16217 9.24994 8.16217ZM1.74994 1.66211C1.61206 1.66211 1.5 1.77417 1.5 1.91205V6.41205C1.5 6.55011 1.61206 6.66217 1.74994 6.66217H9.24994C9.388 6.66217 9.50006 6.55011 9.50006 6.41205V1.91205C9.50006 1.77417 9.388 1.66211 9.24994 1.66211H1.74994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 24.1639H1.74994C0.784973 24.1639 0 23.3789 0 22.4139V11.9139C0 10.9488 0.784973 10.1638 1.74994 10.1638H9.24994C10.2151 10.1638 11.0001 10.9488 11.0001 11.9139V22.4139C11.0001 23.3789 10.2151 24.1639 9.24994 24.1639ZM1.74994 11.6638C1.61206 11.6638 1.5 11.7759 1.5 11.9139V22.4139C1.5 22.5518 1.61206 22.6639 1.74994 22.6639H9.24994C9.388 22.6639 9.50006 22.5518 9.50006 22.4139V11.9139C9.50006 11.7759 9.388 11.6638 9.24994 11.6638H1.74994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 24.1639H14.7501C13.785 24.1639 13 23.3789 13 22.4139V17.9139C13 16.9488 13.785 16.1638 14.7501 16.1638H22.2501C23.2151 16.1638 24.0001 16.9488 24.0001 17.9139V22.4139C24.0001 23.3789 23.2151 24.1639 22.2501 24.1639ZM14.7501 17.6638C14.6121 17.6638 14.5 17.7759 14.5 17.9139V22.4139C14.5 22.5518 14.6121 22.6639 14.7501 22.6639H22.2501C22.388 22.6639 22.5001 22.5518 22.5001 22.4139V17.9139C22.5001 17.7759 22.388 17.6638 22.2501 17.6638H14.7501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 14.1622H14.7501C13.785 14.1622 13 13.3772 13 12.412V1.91205C13 0.947083 13.785 0.162109 14.7501 0.162109H22.2501C23.2151 0.162109 24.0001 0.947083 24.0001 1.91205V12.412C24.0001 13.3772 23.2151 14.1622 22.2501 14.1622ZM14.7501 1.66211C14.6121 1.66211 14.5 1.77417 14.5 1.91205V12.412C14.5 12.5501 14.6121 12.6622 14.7501 12.6622H22.2501C22.388 12.6622 22.5001 12.5501 22.5001 12.412V1.91205C22.5001 1.77417 22.388 1.66211 22.2501 1.66211H14.7501Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_51327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.162109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.7adf9b9eaa88a5d8cd26c99dc466cdba.svg";
export { ForwardRef as ReactComponent };